
import { Component, Vue } from 'vue-property-decorator'
import appBar from '@/components/AppBar.vue'
import BaseVue from '@/components/BaseVue'
import { Authority } from '../models/Authority'
import { WorkingDetail } from '../models/WorkingDetail'
import { Request } from '../models/Request'
import { BaseTime } from '../models/BaseTime'
import { Pulldown } from '../models/Pulldown'
import { LogData } from '../models/LogData'
import { SearchCondition } from '../models/WorkingListSearchCondition'
import { Const } from '../scripts/Const'
import { MsgConst } from '../scripts/MsgConst'
import { StringUtil } from '../scripts/StringUtil'
@Component({
	components: { appBar }
})
export default class AttendanceEntryView extends BaseVue {
	//#region 定数
	private readonly CAN_REGIST_MANUAL_EXCHANGE_DATE_TO = '2022-05-31'
	//#endregion

	//#region 変数
	private editCondition: WorkingDetail = new WorkingDetail()
	private baseTime: BaseTime = new BaseTime()
	private workingRequestEditCondition: Request = new Request()
	private vacationRequestEditCondition: Request = new Request()
	private lateEarlyRequest1EditCondition: Request = new Request()
	private lateEarlyRequest2EditCondition: Request = new Request()
	private authority: Authority = new Authority()
	//private logs: LogData = new LogData()
    private logs: LogData[] = []
	private searchCondition: SearchCondition = new SearchCondition()	//勤務一覧画面用の検索条件

	//関連する勤務明細の更新日時(排他制御用)
    private exchangeDaySearchResultWorkingDate = ''	//振替日
    private exchangeDaySearchResultRenewDate = ''	//振替日更新日時
    private offDutyDaySearchResultWorkingDate = ''	//明休日
    private offDutyDaySearchResultRenewDate = ''	//明休更新日時
    private yesterdaySearchResultRenewDate = ''		//前日更新日時
    private tomorrowSearchResultRenewDate = ''		//翌日更新日時
    private queryExcecuteDatabaseTimestamp = ''		//画面を開いた時点の現在日時(振替日、明け休み確認用)

	private timeChangeFlg = false
	private eventNm = ''

	//#region カレンダー
	private menu = false
	private menu2 = false
	private menu3 = false
	private date = new Date().toISOString().substr(0, 10)
	//#endregion

	//#region 表示制御
	//申請理由
	private shiftReason = false
	private vacationReason = false
	private lateReason = false
	private lateReason2 = false
	//決裁理由
	private showDecisionRemarks = false
    private showDecisionRemarksDialog = false	//管理職承認・否認時入力用
	//遅早退２
	private late2 = false
    //明休日
    private isNextDayOffDuty = false
	//休憩内訳
	private breakdown = false
	//在宅勤務
	private teleWork = false
	private teleWork2 = false
	//ログ
	private showLog = false
	//振替日
	private showExchangeTo = false
	private showExchangeFrom = false
	//ボタン
    private showDefaultWorkTimebtn = false
	private showSavebtn = false
	private showCancelbtn = false
	private showConfirmbtn = false
	private showApprovalbtn = false
	private showRejectbtn = false
	private showHolidayWorkbtn = false
	//#endregion

	//#region 活性制御
	//休日区分
	private disableHoliday = true
	//シフト勤務時間
	private freeShift = false
	//その他時間項目
	private timeInput = true
	private restTimeInput = true
	//申請
	private disableWorking = false
	private disableVacation = false
	private disableRequest2 = false
	private disableVacationReason = false
    private disableExchangeDateFrom = true	//システム化前の振替日発生日がある移行期間中のみ触れる。既定値は禁止しておく。
	//ボタン
	private disableSavebtn: boolean
	private disableCancelbtn: boolean
	private disableConfirmbtn: boolean
	private disableApprovalbtn: boolean
	private disableRejectbtn: boolean
	private disableHolidayWorkbtn: boolean
	//決済理由
	private disabledecision = false
	private disableRemarks = false
	//#endregion

	//#region メッセージ
	private showMessage = false
    private messageType = 'info'
	private message = ''
	//#endregion

    //#region ガイダンス
    private showGuidance = false
    private guidanceType = 'info'
    private guidance = ''
	//#endregion

	//#region ダイアログ
	private dialog = false
	private title = ''
	private dialogMsg = ''
	//#endregion

	//#region プルダウン
	private holidayList: Pulldown[] = []
	private workingList: Pulldown[] = []
	private vacationList: Pulldown[] = []
	private lateEarlyList: Pulldown[] = [
		{ nm: '遅刻', cd: '10' },
		{ nm: '早退', cd: '20' },
		{ nm: '電車遅延', cd: '30' }
	]
	private selectLate: string
	private selectLate2: string
	//#endregion

	//#region 時間背景色
	private shiftColor = 'white'
	private colorWkTimeStart = 'white'
	private colorWkTimeEnd = 'white'
	private colorRestTimeStart1 = 'white'
	private colorReestTimeEnd1 = 'white'
	private colorRestTimeStart2 = 'white'
	private colorRestTimeEnd2 = 'white'
	private colorRestTimeStart3 = 'white'
	private colorRestTimeEnd3 = 'white'
	private colorRestTimeStart4 = 'white'
	private colorRestTimeEnd4 = 'white'
	private colorRestTimeStart5 = 'white'
	private colorRestTimeEnd5 = 'white'
	private colorRestTimeStart6 = 'white'
	private colorRestTimeEnd6 = 'white'
	private colorRestTimeStart7 = 'white'
	private colorRestTimeEnd7 = 'white'
	private colorRestTimeStart8 = 'white'
	private colorRestTimeEnd8 = 'white'
	private colorRestTimeStart9 = 'white'
	private colorRestTimeEnd9 = 'white'
	private colorRestTimeStart10 = 'white'
	private colorReestTimeEnd10 = 'white'

	//#endregion

	//#region 申請背景色
	private workingRequestColor = 'white'
	private vacationRequestColor = 'white'
	private lateEarlyRequest1Color = 'white'
	private lateEarlyRequest2Color = 'white'
	//#endregion

	//#endregion

	//#region 初期表示
	private async created() {
		this.init()
        this.clearMessage()

		this.editCondition = new WorkingDetail()
		this.baseTime = new BaseTime()

		this.editCondition.workingDate = this.$route.params.workingDate
		this.editCondition.empCd = this.$route.params.empCd

		this.searchCondition.workingYm = this.$route.params.workingYm
		this.searchCondition.empCd = this.$route.params.empCd
		this.searchCondition.beforeViewName = this.$route.params.beforeViewName
		this.searchCondition.beforeViewParam1 = this.$route.params.beforeViewParam1
		this.searchCondition.beforeViewParam2 = this.$route.params.beforeViewParam2
		this.searchCondition.beforeViewParam3 = this.$route.params.beforeViewParam3
		//勤務情報の取得
		this.getWorkingDetail()
	}

	//#endregion

    //#region 日付を前日に変更
    private changePreviousDay() {

        var prevDate = new Date(this.editCondition.workingDate);
        // 前日を求める
        prevDate.setDate(prevDate.getDate() - 1);

        this.editCondition.workingDate = prevDate.toISOString().substr(0, 10);

		this.changeDate()
    }
	//#endregion

    //#region 日付を翌日に変更
    private changeNextDay() {

        var nextDate = new Date(this.editCondition.workingDate);
        // 翌日を求める
		nextDate.setDate(nextDate.getDate() + 1);

        this.editCondition.workingDate = nextDate.toISOString().substr(0, 10);

        this.changeDate()
    }
	//#endregion

	//#region 日付変更
	private changeDate() {
		this.init()
        this.clearMessage()

		//勤務情報の取得
		this.getWorkingDetail()

		//画面上部へスクロール
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	//#endregion

	//#region 登録ボタン押下
	private clickSave() {
        this.showDecisionRemarksDialog = false
		//確認ダイアログ
		this.eventNm = 'edit'
		this.openDialog('確認', MsgConst.COMMON.CONFIRM_009)
	}
	//#endregion

	//#region 申請取消ボタン押下
	private clickCancel() {
        this.showDecisionRemarksDialog = false
		//確認ダイアログ
		this.eventNm = 'cancel'
		this.openDialog('確認', MsgConst.COMMON.CONFIRM_010)
	}
	//#endregion

	//#region 休日出勤申請取消ボタン押下
	private clickCancelHolidayWork() {
        this.showDecisionRemarksDialog = false
		//確認ダイアログ
		this.eventNm = 'cancelHolidayWork'
        this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_011, '【休日出勤申請】'))
	}
	//#endregion

	//#region 確認ボタン押下
	private clickConfirm() {
        this.showDecisionRemarksDialog = false
		//確認ダイアログ
		this.eventNm = 'confirm'
		this.openDialog('確認', MsgConst.COMMON.CONFIRM_012)
	}
	//#endregion

	//#region 承認ボタン押下
	private clickApproval() {
        this.showDecisionRemarksDialog = true
		//確認ダイアログ
		this.eventNm = 'approval'
		this.openDialog('確認', MsgConst.COMMON.CONFIRM_013)
	}
	//#endregion

	//#region 否認ボタン押下
	private clickReject() {
        this.showDecisionRemarksDialog = true
		//確認ダイアログ
		this.eventNm = 'reject'
		this.openDialog('確認', MsgConst.COMMON.CONFIRM_014)
	}
	//#endregion

	//#region 戻るボタン押下
	private clickClose() {
        var workingYm = this.editCondition.workingDate.substr(0, 7).replace('-', '')
        var empCd = this.editCondition.empCd

        this.$store.commit('navigation/POP_HISTORY') // 現在画面を削除
        const previous = this.$store.getters['navigation/lastPage'] // ひとつ前を取得

        if (previous) {
            this.$router.push({
                name: previous.name,
                params: {
                    workingYm: workingYm,
                    empCd: empCd,
                    beforeViewName: this.searchCondition.beforeViewName,
                    beforeViewParam1: this.searchCondition.beforeViewParam1,
                    beforeViewParam2: this.searchCondition.beforeViewParam2,
					beforeViewParam3: this.searchCondition.beforeViewParam3,
                    isBack: true
                } as any
            })
        } else {
            this.$router.push({ name: 'Menu' })
        }
    }
	//#endregion

    //#region 勤務開始時間フォーカスイベント
    private wkTimeStart_Focus() {

        //フォーカスが当たった時点で勤務開始時間が空欄なら、始業時間(シフト勤務開始時間)を既定値として設定する。
        if (this.editCondition.wkTimeStart == '' && this.editCondition.shiftTimeStart != "") {
            this.editCondition.wkTimeStart = this.editCondition.shiftTimeStart
        }
    }
	//#endregion

    //#region 定時勤務ボタンクリックイベント
    private DefaultWorkTimebtn_Click() {

		//クリックされた時点で勤務開始時間・終了時間が空欄なら、始業時間・終業時間(シフト勤務開始時間・終了時間)を既定値として設定する。
        if (this.editCondition.wkTimeStart == '' && this.editCondition.shiftTimeStart != "") {
            this.editCondition.wkTimeStart = this.editCondition.shiftTimeStart
		}
        if (this.editCondition.wkTimeEnd == '' && this.editCondition.shiftTimeEnd != "") {
            this.editCondition.wkTimeEnd = this.editCondition.shiftTimeEnd
        }
    }
	//#endregion

	//#region 時間項目チェンジイベント
	private changeTime() {
		this.timeChangeFlg = false
		this.editCondition.restTimeChangeFlg = false

		if (this.editCondition.shiftTimeStart == this.editCondition.wkTimeStart || this.editCondition.wkTimeStart == '') {
			this.colorWkTimeStart = 'white'
		} else {
			this.colorWkTimeStart = 'yellow lighten-2'
			this.timeChangeFlg = true
		}
		if (
			this.editCondition.shiftTimeStart > this.editCondition.wkTimeEnd ||
			this.editCondition.shiftTimeEnd <= this.editCondition.wkTimeEnd
		) {
			this.colorWkTimeEnd = 'white'
		} else {
			this.colorWkTimeEnd = 'yellow lighten-2'
			this.timeChangeFlg = true
		}
		if (this.baseTime.restTimeStart1 == this.editCondition.restTimeStart1) {
			this.colorRestTimeStart1 = 'white'
		} else {
			this.colorRestTimeStart1 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeEnd1 == this.editCondition.restTimeEnd1) {
			this.colorReestTimeEnd1 = 'white'
		} else {
			this.colorReestTimeEnd1 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeStart2 == this.editCondition.restTimeStart2) {
			this.colorRestTimeStart2 = 'white'
		} else {
			this.colorRestTimeStart2 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeEnd2 == this.editCondition.restTimeEnd2) {
			this.colorRestTimeEnd2 = 'white'
		} else {
			this.colorRestTimeEnd2 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeStart3 == this.editCondition.restTimeStart3) {
			this.colorRestTimeStart3 = 'white'
		} else {
			this.colorRestTimeStart3 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeEnd3 == this.editCondition.restTimeEnd3) {
			this.colorRestTimeEnd3 = 'white'
		} else {
			this.colorRestTimeEnd3 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeStart4 == this.editCondition.restTimeStart4) {
			this.colorRestTimeStart4 = 'white'
		} else {
			this.colorRestTimeStart4 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeEnd4 == this.editCondition.restTimeEnd4) {
			this.colorRestTimeEnd4 = 'white'
		} else {
			this.colorRestTimeEnd4 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeStart5 == this.editCondition.restTimeStart5) {
			this.colorRestTimeStart5 = 'white'
		} else {
			this.colorRestTimeStart5 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeEnd5 == this.editCondition.restTimeEnd5) {
			this.colorRestTimeEnd5 = 'white'
		} else {
			this.colorRestTimeEnd5 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeStart6 == this.editCondition.restTimeStart6) {
			this.colorRestTimeStart6 = 'white'
		} else {
			this.colorRestTimeStart6 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeEnd6 == this.editCondition.restTimeEnd6) {
			this.colorRestTimeEnd6 = 'white'
		} else {
			this.colorRestTimeEnd6 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeStart7 == this.editCondition.restTimeStart7) {
			this.colorRestTimeStart7 = 'white'
		} else {
			this.colorRestTimeStart7 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeEnd7 == this.editCondition.restTimeEnd7) {
			this.colorRestTimeEnd7 = 'white'
		} else {
			this.colorRestTimeEnd7 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeStart8 == this.editCondition.restTimeStart8) {
			this.colorRestTimeStart8 = 'white'
		} else {
			this.colorRestTimeStart8 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeEnd8 == this.editCondition.restTimeEnd8) {
			this.colorRestTimeEnd8 = 'white'
		} else {
			this.colorRestTimeEnd8 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeStart9 == this.editCondition.restTimeStart9) {
			this.colorRestTimeStart9 = 'white'
		} else {
			this.colorRestTimeStart9 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeEnd9 == this.editCondition.restTimeEnd9) {
			this.colorRestTimeEnd9 = 'white'
		} else {
			this.colorRestTimeEnd9 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeStart10 == this.editCondition.restTimeStart10) {
			this.colorRestTimeStart10 = 'white'
		} else {
			this.colorRestTimeStart10 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
		if (this.baseTime.restTimeEnd10 == this.editCondition.restTimeEnd10) {
			this.colorReestTimeEnd10 = 'white'
		} else {
			this.colorReestTimeEnd10 = 'yellow lighten-2'
			this.editCondition.restTimeChangeFlg = true
		}
	}
	//#endregion

    //#region 休暇区分チェンジイベント
	private holidayChange() {
		//移行期間用の振替休日申請のみ許す対策
		//「振替休日申請なのに振替日および振替元日付が未設定のもの」が、振替休日申請を手動作成した申請
		if (!(this.editCondition.vacationKbn == Const.VacationKbn.TRANSFER_HOLIDAY
            && this.editCondition.workingDate <= this.CAN_REGIST_MANUAL_EXCHANGE_DATE_TO
            && this.editCondition.exchangeDateBase == null
			&& this.editCondition.exchangeDateTo == null)) {
			//上記条件を満たさない場合は、管理側で休日区分を操作して際と判断し、勤務区分と休暇区分を再取得する。
            this.getPulldownList()
        }
    }
	//#endregion

	//#region 勤務区分チェンジイベント
	private workChange() {
		switch (this.editCondition.workingKbn) {
		case Const.WorkingKbn.INDIVIDUAL_SHIFT:
			//個別シフト
			this.shiftReason = true
			this.breakdown = true
			break
		case Const.WorkingKbn.HOLIDAY_WORK:
			//休日出勤の場合
			this.shiftReason = true
			this.breakdown = true
			break
		case Const.WorkingKbn.NON_WORKINGDAY:
			//非勤務日の場合
			this.nonWorkingDay()
			this.displayControl()
			break
		default:
			//その他勤務区分変更
			if (this.timeChangeFlg || this.editCondition.restTimeChangeFlg) {
				this.eventNm = 'overwriteTime'
				this.openDialog('確認', MsgConst.ATTENDANCE_ENTRY.CONFIRM_001)
			} else {
				this.overwriteTime()
			}
			this.shiftReason = false
			this.workingRequestEditCondition.requestRemarks = ''
		}
		this.displayControl()
		this.changeTime()

		this.showCancelbtn = false	//振替休日に「休日出勤」を選択するが、登録前にキャンセルを押された時にバグる対策
	}
	//#endregion

	//#region 休暇区分チェンジイベント
	private vacationChange() {
		switch (this.editCondition.vacationKbn) {
		case Const.VacationKbn.DEFAULT:
			this.vacationReason = false
			//設定なし・個別設定シフトでない
			if (!this.freeShift) {
				this.editCondition.shiftTimeStart = this.baseTime.shiftTimeStart
				this.editCondition.shiftTimeEnd = this.baseTime.shiftTimeEnd
				this.setRestTime()
			}
			break
		case Const.VacationKbn.PAID_HOLIDAY_AM_BEFORE:
		case Const.VacationKbn.PAID_HOLIDAY_AM_THEDAY:
		case Const.VacationKbn.SPECIAL_HOLIDAY_AM:
		case Const.VacationKbn.ABSENCE_AM:
		case Const.VacationKbn.PAID_HOLIDAY_PM_BEFORE:
		case Const.VacationKbn.PAID_HOLIDAY_PM_THEDAY:
		case Const.VacationKbn.SPECIAL_HOLIDAY_PM:
		case Const.VacationKbn.ABSENCE_PM:
			//半休
			this.setOffTime()
			this.setRestTime()
			this.vacationReason = true
			break
		default:
			//全日休暇
			this.vacationReason = true
			//シフト時間の設定 => 休暇でも出勤の場合があるため
			if (!this.freeShift) {
				this.editCondition.shiftTimeStart = this.baseTime.shiftTimeStart
				this.editCondition.shiftTimeEnd = this.baseTime.shiftTimeEnd
				this.setRestTime()
			}
			if (this.editCondition.wkTimeStart || this.editCondition.wkTimeEnd) {
				//確認ダイアログ
				this.eventNm = 'setAlldayOff'
				this.openDialog('確認', MsgConst.ATTENDANCE_ENTRY.CONFIRM_002)
			}
		}
		this.displayControl()
		this.changeTime()
	}
	//#endregion

	//#region 遅刻チェンジイベント
	private changeLateReason() {
		if (this.selectLate === null) {
			this.lateReason = false
			this.lateEarlyRequest1EditCondition.requestRemarks = ''
			this.clearMessage()
		} else {
			this.lateReason = true
		}
	}
	private changeLateReason2() {
		if (this.selectLate2 === null) {
			this.lateReason2 = false
			this.late2 = false
			this.lateEarlyRequest2EditCondition.requestRemarks = ''
			this.clearMessage()
		} else {
			this.lateReason2 = true
		}
	}
	//#endregion

	//#region シフト勤務時間チェンジイベント
	private changeShitTime() {
		//休憩時間計算
		this.calcRest()
	}
	//#endregion

	//#region 在宅勤務チェック チェンジイベント
	private changeTelework() {
		//入力がない場合 業務開始終了時間の反映
		if (this.teleWork && !this.editCondition.teleworkStart1 && !this.editCondition.teleworkEnd1) {
			this.editCondition.teleworkStart1 = this.editCondition.wkTimeStart
			this.editCondition.teleworkEnd1 = this.editCondition.wkTimeEnd
		}
	}
	//#endregion

    //#region 翌営業日明休日チェック チェンジイベント
	private changeIsNextDayOffDuty() {
        if (this.isNextDayOffDuty) {
			//翌営業日明休日取得
			this.GetNextWorkingDate()
		} else {
            this.editCondition.offDutyDate = ''
        }
    }
	//#endregion

	//#region プライベート

	//#region 登録
	private edit() {
		this.clearMessage()

		//在宅勤務非表示の場合 登録しない
		this.EditTele()

		////明休日非表示の場合 登録しない
        this.EditOffDutyDate()

		////日付基準時間の設定
		//if (this.freeShift) {
		//	this.editCondition.dateBaseTime = this.editCondition.shiftTimeStart
		//} else {
		//	this.editCondition.dateBaseTime = this.baseTime.shiftTimeStart
		//}

		//遅早退フラグ変換 かつ 遅早退チェック
		if (!this.setLateEarlyFlg()) {
			return
		} else {
			//登録
			this.editWorkingDetail()
		}

		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	//#endregion

	//#region 申請取消
	private cancel() {
		this.clearMessage()

		//申請取消
		this.cancelRequest()

		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	//#endregion

	//#region 確認
	private confirm() {
		this.clearMessage()

		this.confirmWorkingDetail()
	}
	//#endregion

	//#region 承認
	private approval() {
		this.clearMessage()

		//決裁理由を各申請にセットする
		this.setDecisionRemarks()
		this.approvalWorkingDetail()
	}
	//#endregion

	//#region 否認
	private reject() {
		this.clearMessage()

		//決裁理由を各申請にセットする
		this.setDecisionRemarks()
		this.rejectWorkingDetail()
	}
	//#endregion

    //#region ガイダンスを表示する
    private getGuidance(dailyStatus: string) {
        //何をすべきかガイダンスする
		this.showGuidance = false
        this.guidance = ''

		this.guidanceType = 'info'

		////否認判定(申請はGetメソッドで確認しているので、勤務明細のみ判定)
		if (dailyStatus == Const.DailyStatus.REMAND && this.showMessage == false) {
			this.guidanceType = 'error'
			this.guidance += MsgConst.COMMON.ERROR_001
            this.showGuidance = true
            return
        }

		//申請の未登録(休暇取消で遅刻早退が後付けで発生した場合など・・・)
		if (this.editCondition.workingKbn != Const.WorkingKbn.NON_WORKINGDAY) {
			if (this.workingRequestEditCondition.requestStatus == Const.RequestStatus.MAKING
				|| this.workingRequestEditCondition.requestStatus == Const.RequestStatus.REMAND) {
                this.guidance += '勤務区分'
			}
			if (this.vacationRequestEditCondition.requestStatus == Const.RequestStatus.MAKING
				|| this.vacationRequestEditCondition.requestStatus == Const.RequestStatus.REMAND) {
                this.guidance += this.guidance != '' ? '・' : ''
                this.guidance += '休暇'
			}
			if (this.lateEarlyRequest1EditCondition.requestStatus == Const.RequestStatus.MAKING
				|| this.lateEarlyRequest1EditCondition.requestStatus == Const.RequestStatus.REMAND
				|| (this.lateEarlyRequest1EditCondition.requestStatus == null && this.selectLate >= '10')
			) {
                this.guidance += this.guidance != '' ? '・' : ''
                this.guidance += '遅早退１'
			}
			if (this.lateEarlyRequest2EditCondition.requestStatus == Const.RequestStatus.MAKING
				|| this.lateEarlyRequest2EditCondition.requestStatus == Const.RequestStatus.REMAND
                || (this.lateEarlyRequest2EditCondition.requestStatus == null && this.selectLate2 >= '10')
			) {
                this.guidance += this.guidance != '' ? '・' : ''
                this.guidance += '遅早退２'
            }
			if (this.guidance != '') {
				this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_005, this.guidance)
                this.showGuidance = true
                return;
            }
        }

		//承認待ち判定
		if (this.workingRequestEditCondition.requestStatus == Const.RequestStatus.AWAITING_APPROVAL
			|| this.vacationRequestEditCondition.requestStatus == Const.RequestStatus.AWAITING_APPROVAL
            || this.lateEarlyRequest1EditCondition.requestStatus == Const.RequestStatus.AWAITING_APPROVAL
            || this.lateEarlyRequest2EditCondition.requestStatus == Const.RequestStatus.AWAITING_APPROVAL) {
            this.guidance += '申請'
		}
		if (dailyStatus == Const.DailyStatus.MAKING || dailyStatus == Const.DailyStatus.AWAITING_APPROVAL ) {
			if (this.editCondition.wkTimeEnd) {
				this.guidance += this.guidance != '' ? '・' : ''
				this.guidance += '勤務時間'
			}
		}
        if (this.guidance != '') {
			if (this.showApprovalbtn == true) {
				this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_001, this.guidance) 
			} else {
				this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_002, this.guidance)
			}
            this.showGuidance = true
            return
        }

		//承認済み判定
		if (this.workingRequestEditCondition.requestStatus == Const.RequestStatus.APPROVED
            || this.vacationRequestEditCondition.requestStatus == Const.RequestStatus.APPROVED
            || this.lateEarlyRequest1EditCondition.requestStatus == Const.RequestStatus.APPROVED
            || this.lateEarlyRequest2EditCondition.requestStatus == Const.RequestStatus.APPROVED) {
            this.guidance += '申請'
		}
		if (dailyStatus == Const.DailyStatus.APPROVED) {
			this.guidance += this.guidance != '' ? '・' : ''
			this.guidance += '勤務時間'
		}
		if (this.guidance != '') {
			this.guidance = MsgConst.COMMON.INFO_003
            this.showGuidance = true
            return
		}

		//締済み判定
		if (dailyStatus == Const.DailyStatus.CLOSING) {
            this.guidance = MsgConst.COMMON.INFO_004
            this.showGuidance = true
            return
		}

		//新規ではない作りかけの状態を警告する(申請優先に判定したいので後方で判定)
		if (dailyStatus == Const.DailyStatus.MAKING || dailyStatus == Const.DailyStatus.AWAITING_APPROVAL) {
			if (this.editCondition.workingKbn != Const.WorkingKbn.NON_WORKINGDAY //非勤務日ではない
                &&
				(
					this.editCondition.vacationKbn == Const.VacationKbn.DEFAULT	//勤務
					|| this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_AM_BEFORE	//AM休(事前)
					|| this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_PM_BEFORE	//PM休(事前)
					|| this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_AM_THEDAY	//AM休(当日)
					|| this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_PM_THEDAY	//PM休(当日)
					|| this.editCondition.vacationKbn == Const.VacationKbn.SPECIAL_HOLIDAY_AM	//特休(AM)
					|| this.editCondition.vacationKbn == Const.VacationKbn.SPECIAL_HOLIDAY_PM	//特休(PM)
					|| this.editCondition.vacationKbn == Const.VacationKbn.ABSENCE_AM	//半欠勤AM
                    || this.editCondition.vacationKbn == Const.VacationKbn.ABSENCE_PM	//半欠勤PM
                )
				&& this.editCondition.wkTimeEnd == '')
			{
                this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_006 , '勤務時間')
                this.showGuidance = true
                return
            }
		}

		//月次ステータスによる判定
		if ((dailyStatus == Const.DailyStatus.NEW || dailyStatus == Const.DailyStatus.MAKING) && this.editCondition.monthlyStatus == Const.MonthlyStatus.AWAITING_APPROVAL) {
            this.guidance += MsgConst.ATTENDANCE_ENTRY.INFO_001
            this.showGuidance = true
            return
        }

    }
	//#endregion

	//#region 勤務情報・申請情報取得
    private async getWorkingDetail() {
		try {
			const data = {
				EditCondition: this.editCondition
			}

			const response = await this.$axios.post('api/AttendanceEntry/Get', data)

            //webLogicのレスポンスにメッセージがある場合は表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (response.data.messageData.errFlg) {

                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
					return
				}
			}

			//権限
			this.authority = response.data.authority
			//勤務時間
			this.editCondition = response.data.editCondition
			this.baseTime = response.data.baseTime

            //申請情報
            this.workingRequestEditCondition = response.data.workingRequestEditCondition
            this.vacationRequestEditCondition = response.data.vacationRequestEditCondition
            this.lateEarlyRequest1EditCondition = response.data.lateEarlyRequest1EditCondition
            this.lateEarlyRequest2EditCondition = response.data.lateEarlyRequest2EditCondition
			//関連する勤務日の更新日時(排他制御用)
            this.exchangeDaySearchResultWorkingDate = response.data.exchangeDaySearchResultWorkingDate	//振替日
            this.exchangeDaySearchResultRenewDate = response.data.exchangeDaySearchResultRenewDate		//振替日更新日時
            this.offDutyDaySearchResultWorkingDate = response.data.offDutyDaySearchResultWorkingDate	//明休日
            this.offDutyDaySearchResultRenewDate = response.data.offDutyDaySearchResultRenewDate		//明休日更新日時
            this.yesterdaySearchResultRenewDate = response.data.yesterdaySearchResultRenewDate			//前日更新日時
            this.tomorrowSearchResultRenewDate = response.data.tomorrowSearchResultRenewDate			//翌日更新日時
            this.queryExcecuteDatabaseTimestamp = response.data.queryExcecuteDatabaseTimestamp			//現在日時
			//プルダウン
			this.holidayList = response.data.holidayList
			this.workingList = response.data.workingList
			this.vacationList = response.data.vacationList
			//ログ
			this.logs = response.data.logList
			//表示制御
			this.displayLateEarly()
			this.requestBackColor()
			this.displayControl()
			this.changeTime()

            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.dailyStatus)

			//画面上部へスクロール
			window.scrollTo({ top: 0, behavior: 'smooth' })
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

    //#region 勤務区分・休暇区分取得
    private async getPulldownList() {
        try {
            const data = {
                EditCondition: this.editCondition
            }

			//休日区分に基づいて勤務区分・休暇区分のプルダウンリスト用データを再取得する
            const response = await this.$axios.post('api/AttendanceEntry/GetPulldownList', data)

            //webLogicのレスポンスにメッセージがある場合は表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (response.data.messageData.errFlg) {
                    //変更を打ち消すため、画面を初期化し再度読み込み
                    this.init()
                    this.getWorkingDetail()
                }
            }

            //勤務時間
            this.baseTime = response.data.baseTime

            //プルダウン
            this.workingList = response.data.workingList
			this.vacationList = response.data.vacationList

			//休日区分に基づいて勤務区分を設定
			switch (this.editCondition.holidayKbn) {
				case Const.HolidayKbn.WEEKDAY:
					//平日
					this.editCondition.workingKbn = Const.WorkingKbn.REGULAR_WORK
                    break
                default:
					//法定外休日・法定休日
					this.editCondition.workingKbn = Const.WorkingKbn.NON_WORKINGDAY
					this.editCondition.vacationKbn = Const.VacationKbn.DEFAULT
                    break
			}

			//勤務区分に基づく再描画
			this.workChange()

            //表示制御

            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.dailyStatus)

            //画面上部へスクロール
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } catch (e) {
            console.log(e.message)
        }
    }
	//#endregion

	//#region 勤務情報登録
	private async editWorkingDetail() {
		try {
			const data = {
				EditCondition: this.editCondition,
				BaseTime: this.baseTime,
				WorkingRequestEditCondition: this.workingRequestEditCondition,
				VacationRequestEditCondition: this.vacationRequestEditCondition,
				LateEarlyRequest1EditCondition: this.lateEarlyRequest1EditCondition,
				LateEarlyRequest2EditCondition: this.lateEarlyRequest2EditCondition,
                ExchangeDaySearchResultWorkingDate: this.exchangeDaySearchResultWorkingDate,
                ExchangeDaySearchResultRenewDate: this.exchangeDaySearchResultRenewDate,
                OffDutyDaySearchResultWorkingDate: this.offDutyDaySearchResultWorkingDate,
                OffDutyDaySearchResultRenewDate: this.offDutyDaySearchResultRenewDate,
                YesterdaySearchResultRenewDate: this.yesterdaySearchResultRenewDate,
                TomorrowSearchResultRenewDate: this.tomorrowSearchResultRenewDate,
                QueryExcecuteDatabaseTimestamp: this.queryExcecuteDatabaseTimestamp
			}

			const response = await this.$axios.post('api/AttendanceEntry/Edit', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					//画面を初期化し再度読み込み
					this.init()
					this.getWorkingDetail()
				}
				return
			}
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.dailyStatus)

		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務情報確認
	private async confirmWorkingDetail() {
		try {
			const data = {
				EditCondition: this.editCondition,
				WorkingRequestEditCondition: this.workingRequestEditCondition,
				VacationRequestEditCondition: this.vacationRequestEditCondition,
				LateEarlyRequest1EditCondition: this.lateEarlyRequest1EditCondition,
				LateEarlyRequest2EditCondition: this.lateEarlyRequest2EditCondition,
                ExchangeDaySearchResultWorkingDate: this.exchangeDaySearchResultWorkingDate,
				ExchangeDaySearchResultRenewDate: this.exchangeDaySearchResultRenewDate,
                OffDutyDaySearchResultWorkingDate: this.offDutyDaySearchResultWorkingDate,
                OffDutyDaySearchResultRenewDate: this.offDutyDaySearchResultRenewDate,
                YesterdaySearchResultRenewDate: this.yesterdaySearchResultRenewDate,
                TomorrowSearchResultRenewDate: this.tomorrowSearchResultRenewDate,
                QueryExcecuteDatabaseTimestamp: this.queryExcecuteDatabaseTimestamp
			}
			const response = await this.$axios.post('api/AttendanceEntry/Confirm', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					//画面を初期化し再度読み込み
                    this.init()
					this.getWorkingDetail()
				}
				return
			}
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.dailyStatus)

		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務情報承認
	private async approvalWorkingDetail() {
		try {
			const data = {
				EditCondition: this.editCondition,
				WorkingRequestEditCondition: this.workingRequestEditCondition,
				VacationRequestEditCondition: this.vacationRequestEditCondition,
				LateEarlyRequest1EditCondition: this.lateEarlyRequest1EditCondition,
				LateEarlyRequest2EditCondition: this.lateEarlyRequest2EditCondition,
                ExchangeDaySearchResultWorkingDate: this.exchangeDaySearchResultWorkingDate,
				ExchangeDaySearchResultRenewDate: this.exchangeDaySearchResultRenewDate,
                OffDutyDaySearchResultWorkingDate: this.offDutyDaySearchResultWorkingDate,
                OffDutyDaySearchResultRenewDate: this.offDutyDaySearchResultRenewDate,
                YesterdaySearchResultRenewDate: this.yesterdaySearchResultRenewDate,
                TomorrowSearchResultRenewDate: this.tomorrowSearchResultRenewDate,
                QueryExcecuteDatabaseTimestamp: this.queryExcecuteDatabaseTimestamp
			}
			const response = await this.$axios.post('api/AttendanceEntry/Approval', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					//画面を初期化し再度読み込み
                    this.init()
					this.getWorkingDetail()
				}
				return
			}
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.dailyStatus)

		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務情報否認
	private async rejectWorkingDetail() {
		try {
			const data = {
				EditCondition: this.editCondition,
				WorkingRequestEditCondition: this.workingRequestEditCondition,
				VacationRequestEditCondition: this.vacationRequestEditCondition,
				LateEarlyRequest1EditCondition: this.lateEarlyRequest1EditCondition,
				LateEarlyRequest2EditCondition: this.lateEarlyRequest2EditCondition,
                ExchangeDaySearchResultWorkingDate: this.exchangeDaySearchResultWorkingDate,
				ExchangeDaySearchResultRenewDate: this.exchangeDaySearchResultRenewDate,
                OffDutyDaySearchResultWorkingDate: this.offDutyDaySearchResultWorkingDate,
                OffDutyDaySearchResultRenewDate: this.offDutyDaySearchResultRenewDate,
                YesterdaySearchResultRenewDate: this.yesterdaySearchResultRenewDate,
                TomorrowSearchResultRenewDate: this.tomorrowSearchResultRenewDate,
                QueryExcecuteDatabaseTimestamp: this.queryExcecuteDatabaseTimestamp
			}
			const response = await this.$axios.post('api/AttendanceEntry/Reject', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					//画面を初期化し再度読み込み
                    this.init()
					this.getWorkingDetail()
				}
				return
			}
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.dailyStatus)

		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 申請情報の取消
	private async cancelRequest() {
		try {
			const data = {
				EditCondition: this.editCondition,
				WorkingRequestEditCondition: this.workingRequestEditCondition,
				VacationRequestEditCondition: this.vacationRequestEditCondition,
				LateEarlyRequest1EditCondition: this.lateEarlyRequest1EditCondition,
				LateEarlyRequest2EditCondition: this.lateEarlyRequest2EditCondition,
                ExchangeDaySearchResultWorkingDate: this.exchangeDaySearchResultWorkingDate,
				ExchangeDaySearchResultRenewDate: this.exchangeDaySearchResultRenewDate,
                OffDutyDaySearchResultWorkingDate: this.offDutyDaySearchResultWorkingDate,
                OffDutyDaySearchResultRenewDate: this.offDutyDaySearchResultRenewDate,
                YesterdaySearchResultRenewDate: this.yesterdaySearchResultRenewDate,
                TomorrowSearchResultRenewDate: this.tomorrowSearchResultRenewDate,
                QueryExcecuteDatabaseTimestamp: this.queryExcecuteDatabaseTimestamp
			}

			const response = await this.$axios.post('api/AttendanceEntry/CancelRequest', data)

			this.editCondition = response.data.editCondition
			this.workingRequestEditCondition = response.data.workingRequestEditCondition
			this.vacationRequestEditCondition = response.data.vacationRequestEditCondition
			this.lateEarlyRequest1EditCondition = response.data.lateEarlyRequest1EditCondition
			this.lateEarlyRequest2EditCondition = response.data.lateEarlyRequest2EditCondition

			//表示制御
			this.requestBackColor()
			this.displayControl()

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					//画面を初期化し再度読み込み
                    this.init()
                    this.getWorkingDetail()
				}
				return
			}
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.dailyStatus)

		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 休日申請情報の取消
	private async cancelHolidayWork() {
		try {
			const data = {
				EditCondition: this.editCondition,
				WorkingRequestEditCondition: this.workingRequestEditCondition,
				VacationRequestEditCondition: this.vacationRequestEditCondition,
				LateEarlyRequest1EditCondition: this.lateEarlyRequest1EditCondition,
				LateEarlyRequest2EditCondition: this.lateEarlyRequest2EditCondition,
                ExchangeDaySearchResultWorkingDate: this.exchangeDaySearchResultWorkingDate,
				ExchangeDaySearchResultRenewDate: this.exchangeDaySearchResultRenewDate,
                OffDutyDaySearchResultWorkingDate: this.offDutyDaySearchResultWorkingDate,
                OffDutyDaySearchResultRenewDate: this.offDutyDaySearchResultRenewDate,
                YesterdaySearchResultRenewDate: this.yesterdaySearchResultRenewDate,
                TomorrowSearchResultRenewDate: this.tomorrowSearchResultRenewDate,
                QueryExcecuteDatabaseTimestamp: this.queryExcecuteDatabaseTimestamp
			}

			const response = await this.$axios.post('api/AttendanceEntry/CancelHolidayWork', data)

			this.editCondition = response.data.editCondition
			this.workingRequestEditCondition = response.data.workingRequestEditCondition

			//表示制御
			this.requestBackColor()
			this.displayControl()

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					//画面を初期化し再度読み込み
                    this.init()
					this.getWorkingDetail()
				}
				return
			}
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.dailyStatus)

		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 休憩時間計算
	private async calcRest() {
		const data = {
			EditCondition: this.editCondition
		}

		const response = await this.$axios.post('api/AttendanceEntry/CalcRest', data)

		this.baseTime = response.data.baseTime
		this.editCondition = response.data.editCondition
		this.changeTime()
	}
	//#endregion

	//#region 基準時間変更
	private async changeBaseTime() {
		const data = {
			EditCondition: this.editCondition
		}

		const response = await this.$axios.post('api/AttendanceEntry/ChangeWorkKbn', data)

		this.editCondition = response.data.editCondition
		this.baseTime = response.data.baseTime

		//シフト勤務時間のみ変更
		this.editCondition.shiftTimeStart = this.baseTime.shiftTimeStart
		this.editCondition.shiftTimeEnd = this.baseTime.shiftTimeEnd
		if (
			this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_AM_BEFORE ||
			this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_AM_THEDAY ||
			this.editCondition.vacationKbn == Const.VacationKbn.SPECIAL_HOLIDAY_AM ||
			this.editCondition.vacationKbn == Const.VacationKbn.ABSENCE_AM
		) {
			//午前半休系
			this.editCondition.shiftTimeStart = this.baseTime.afternoonOffTimeStart
			this.editCondition.shiftTimeEnd = this.baseTime.afternoonOffTimeEnd
		} else if (
			this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_PM_BEFORE ||
			this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_PM_THEDAY ||
			this.editCondition.vacationKbn == Const.VacationKbn.SPECIAL_HOLIDAY_PM ||
			this.editCondition.vacationKbn == Const.VacationKbn.ABSENCE_PM
		) {
			//午後半休系
			this.editCondition.shiftTimeStart = this.baseTime.morningOffTimeStart
			this.editCondition.shiftTimeEnd = this.baseTime.morningOffTimeEnd
		}

		this.changeTime()
	}
	//#endregion

	//#region 時間上書き
	private async overwriteTime() {
		const data = {
			EditCondition: this.editCondition
		}

		const response = await this.$axios.post('api/AttendanceEntry/ChangeWorkKbnOverwrite', data)

		this.editCondition = response.data.editCondition
		this.baseTime = response.data.baseTime

		this.setOffTime()
		this.changeTime()
	}
	//#endregion

    //#region 翌営業日明休日取得
    private async GetNextWorkingDate() {
        const data = {
            EditCondition: this.editCondition
        }

        const response = await this.$axios.post('api/AttendanceEntry/GetNextWorkingDate', data)

        if (response.data.messageData.messageList.length > 0) {
            this.showMessage = true
            this.message = response.data.messageData.messageList[0]
            response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
            if (response.data.messageData.errFlg) {
                //翌日明休を無効にする
                this.isNextDayOffDuty = false

                //画面上部へスクロール
                window.scrollTo({ top: 0, behavior: 'smooth' })
                return
            }
            return
        }

        this.editCondition = response.data.editCondition
    }
	//#endregion

	//#region 表示・活性制御
	private displayControl() {
		//#region 本人・管理職
		if (this.editCondition.empCd == this.authority.loginEmpCd || this.authority.roleManager) {
			//休日区分
			this.disableHoliday = true
			//ボタン
			this.showSavebtn = true
			this.disableSavebtn = false
			this.disableCancelbtn = false
			//特記事項
			this.disableRemarks = false
			//本人でない管理職の場合 承認権限あり
			if (this.editCondition.empCd != this.authority.loginEmpCd && this.authority.roleManager) {
				this.showConfirmbtn = true
				this.showApprovalbtn = true
				this.showRejectbtn = true
				this.disabledecision = false
				this.showDecisionRemarks = true
			} else {
				this.showConfirmbtn = false
				this.showApprovalbtn = false
				this.showRejectbtn = false
				this.disabledecision = true
				this.showDecisionRemarks = false
			}

			//時間項目
			if (this.editCondition.workingKbn == Const.WorkingKbn.NON_WORKINGDAY) {
				this.timeInput = false
				this.restTimeInput = false
                this.showDefaultWorkTimebtn = false
			} else {
				this.timeInput = true
				this.restTimeInput = true
                //退勤時間が未設定時のみ、定時勤務ボタンを表示する。
				if (this.editCondition.wkTimeEnd == '') {
					this.showDefaultWorkTimebtn = true
				} else {
                    this.showDefaultWorkTimebtn = false
                }
			}
			//申請済の場合非活性
			if (this.workingRequestEditCondition.detailNo || this.vacationRequestEditCondition.detailNo) {
				this.disableWorking = true
				this.disableVacation = true
				this.disableVacationReason = true
                this.disableExchangeDateFrom = true
			} else {
				this.disableWorking = false
				this.disableVacation = false
				this.disableVacationReason = false
                this.disableExchangeDateFrom = true
			}
			if (this.lateEarlyRequest1EditCondition.detailNo) {
				this.disableRequest2 = true
			} else {
				this.disableRequest2 = false
			}
			//例外 振休かつ休出申請のないときは勤務区分は活性
			if (this.editCondition.vacationKbn == Const.VacationKbn.TRANSFER_HOLIDAY && !this.workingRequestEditCondition.detailNo) {
				this.disableWorking = false
				this.disableVacation = true
				this.disableVacationReason = true
				//例外 振休(申請未登録)かつ勤務日が手動で振替登録できる期限までであれば編集可能
                if (this.editCondition.workingDate <= this.CAN_REGIST_MANUAL_EXCHANGE_DATE_TO && this.editCondition.exchangeDateFrom == null) {
					this.disableVacation = false
					this.disableHoliday = false
                    this.disableExchangeDateFrom = false
                }
			}

			//申請取消ボタン
			if (this.disableWorking || this.disableVacation || this.disableRequest2) {
				this.showCancelbtn = true
			} else {
				this.showCancelbtn = false
			}
			//休日出勤取消ボタン
			if (
				this.editCondition.workingKbn == Const.WorkingKbn.HOLIDAY_WORK &&
				this.workingRequestEditCondition.detailNo &&
				this.editCondition.vacationKbn == Const.VacationKbn.TRANSFER_HOLIDAY &&
				this.vacationRequestEditCondition.detailNo
			) {
				this.showCancelbtn = false
				this.showHolidayWorkbtn = true
				this.disableHolidayWorkbtn = false
			} else {
				this.showHolidayWorkbtn = false
			}

			//勤務時間
			if (this.editCondition.workingKbn == Const.WorkingKbn.INDIVIDUAL_SHIFT || this.editCondition.workingKbn == Const.WorkingKbn.HOLIDAY_WORK) {
				this.freeShift = true
			} else {
				this.freeShift = false
			}
		}
		//#endregion

		//#region 本人・管理職以外
		else {
			//本人・管理職以外の場合
            //休日区分
            this.disableHoliday = true
            //時間・申請 編集不可
            this.freeShift = false
            this.timeInput = false
            this.restTimeInput = false
            this.disableWorking = true
            this.disableVacation = true
            this.disableRequest2 = true
            this.disableVacationReason = true
            this.disableExchangeDateFrom = true
            //決裁不可
            this.disabledecision = true
            this.disableRemarks = true
            //ボタン
            this.showSavebtn = false
            this.showApprovalbtn = false
            this.showCancelbtn = false
            this.showRejectbtn = false
            this.showConfirmbtn = false

			//総務
			if (this.authority.roleWorkingHoursAdmin) {
			}
			//現場リーダー
			if (this.authority.roleLeader || this.authority.roleSales) {
				this.showConfirmbtn = true
			}

			//業務管理
			if (this.authority.roleBusinessAdmin) {
				//休日区分
				this.disableHoliday = false
				this.showSavebtn = true
				this.disableRemarks = false
				//個別シフトの場合シフト時間・休憩時間は入力可にする
				if (this.editCondition.workingKbn == Const.WorkingKbn.INDIVIDUAL_SHIFT || this.editCondition.workingKbn == Const.WorkingKbn.HOLIDAY_WORK) {
					this.freeShift = true
					this.restTimeInput = true
				} else {
					this.freeShift = false
					this.restTimeInput = false
				}
				//申請済の場合非活性
				if (this.workingRequestEditCondition.detailNo || this.vacationRequestEditCondition.detailNo) {
					this.disableWorking = true
					this.disableVacation = true
					this.disableVacationReason = true
                    this.disableExchangeDateFrom = true
				} else {
					this.disableWorking = false
					this.disableVacation = false
					this.disableVacationReason = false
                    this.disableExchangeDateFrom = true
				}
				if (this.lateEarlyRequest1EditCondition.detailNo) {
					this.disableRequest2 = true
				} else {
					this.disableRequest2 = false
				}
				//例外 振休かつ休出申請のないときは勤務区分は活性
				if (this.vacationRequestEditCondition.requestStatus == Const.RequestStatus.MAKING && this.editCondition.vacationKbn == Const.VacationKbn.TRANSFER_HOLIDAY) {
					//申請理由入力可
					this.disableWorking = false
					this.disableVacation = true
					this.disableVacationReason = false
                    this.disableExchangeDateFrom = true
                } else if (this.editCondition.vacationKbn == Const.VacationKbn.TRANSFER_HOLIDAY && !this.workingRequestEditCondition.detailNo) {
					this.disableWorking = false
					this.disableVacation = true
					this.disableVacationReason = true
					this.disableExchangeDateFrom = true
                    //例外 振休(申請未登録)かつ勤務日が手動で振替登録できる期限までであれば編集可能
                    if (this.editCondition.workingDate <= this.CAN_REGIST_MANUAL_EXCHANGE_DATE_TO && this.editCondition.exchangeDateFrom == null) {
						this.disableVacation = false
						this.disableHoliday = false
                        this.disableExchangeDateFrom = false
                    }
				}

				//申請取消ボタン
				if (this.disableWorking || this.disableVacation || this.disableRequest2) {
					this.showCancelbtn = true
				} else {
					this.showCancelbtn = false
				}
				//休日出勤取消ボタン
				if (
					this.editCondition.workingKbn == Const.WorkingKbn.HOLIDAY_WORK &&
					this.workingRequestEditCondition.detailNo &&
					this.editCondition.vacationKbn == Const.VacationKbn.TRANSFER_HOLIDAY &&
					this.vacationRequestEditCondition.detailNo
				) {
					this.showCancelbtn = false
					this.showHolidayWorkbtn = true
					this.disableHolidayWorkbtn = false
				} else {
					this.showHolidayWorkbtn = false
				}
			}
		}
		//#endregion

		//#region 共通
		//共通 活性制御
		if (
			this.editCondition.holidayKbn != Const.HolidayKbn.WEEKDAY &&
			this.editCondition.workingDate <= new Date().toISOString().substr(0, 10)
		) {
			//過去の休日
			this.disableSavebtn = false
			this.disableCancelbtn = false
			this.disableConfirmbtn = false
			this.disableApprovalbtn = false
			this.disableRejectbtn = false
		} else if (
			this.editCondition.dailyStatus == Const.DailyStatus.NEW ||
			this.editCondition.dailyStatus == Const.DailyStatus.MAKING ||
			this.editCondition.dailyStatus == Const.DailyStatus.REMAND
		) {
			//新規・作成中・差戻
			this.disableSavebtn = false
			this.disableCancelbtn = false
			this.disableConfirmbtn = true
			this.disableApprovalbtn = true
			this.disableRejectbtn = true
			this.disabledecision = true
		} else if (this.editCondition.dailyStatus == Const.DailyStatus.AWAITING_APPROVAL) {
			//承認待ち
			this.disableSavebtn = false
			this.disableCancelbtn = false
			this.disableConfirmbtn = false
			this.disableApprovalbtn = false
			this.disableRejectbtn = false
		} else {
			//承認済み
			this.disableSavebtn = true
			this.disableRemarks = true
			this.disableCancelbtn = true
			this.disableConfirmbtn = false
			this.disableApprovalbtn = false
			this.disableRejectbtn = false
			//休日区分
			this.disableHoliday = true
			//時間
			this.freeShift = false
			this.timeInput = false
			this.restTimeInput = false
			//申請項目
			this.disableWorking = true
			this.disableVacation = true
			this.disableRequest2 = true
			this.disableVacationReason = true
            this.disableExchangeDateFrom = true
		}

		//事前申請がある場合確認・承認可能
		if (
			(this.workingRequestEditCondition.detailNo ||
				this.vacationRequestEditCondition.detailNo ||
				this.lateEarlyRequest1EditCondition.detailNo) &&
			this.workingRequestEditCondition.requestStatus != Const.RequestStatus.REMAND &&
			this.vacationRequestEditCondition.requestStatus != Const.RequestStatus.REMAND &&
			this.vacationRequestEditCondition.requestStatus != Const.RequestStatus.MAKING &&
            this.lateEarlyRequest1EditCondition.requestStatus != Const.RequestStatus.REMAND
		) {
			this.disableConfirmbtn = false
			this.disableApprovalbtn = false
			this.disableRejectbtn = false
			if (this.editCondition.empCd != this.authority.loginEmpCd && this.authority.roleManager) {
				this.disabledecision = false
			}
		}

		//本人以外 かつ 業務管理 休日区分変更可能
		if (
			this.editCondition.empCd != this.authority.loginEmpCd &&
			this.authority.roleBusinessAdmin &&
			this.editCondition.dailyStatus != Const.DailyStatus.APPROVED
		) {
			this.disableHoliday = false
		}
		//差戻し申請がある場合 登録ボタン押下不可
		if (
            this.workingRequestEditCondition.requestStatus == Const.RequestStatus.REMAND ||
            this.vacationRequestEditCondition.requestStatus == Const.RequestStatus.REMAND ||
            this.lateEarlyRequest1EditCondition.requestStatus == Const.RequestStatus.REMAND
		) {
			this.disabledecision = true
			this.disableSavebtn = true
			this.disableRemarks = true
			this.errorMessage(MsgConst.ATTENDANCE_ENTRY.ERROR_001)
		}
		//決裁理由 表示のみ
		if (this.editCondition.decisionRemarks) {
			this.showDecisionRemarks = true
		}
		//申請関連
		//勤務申請
		if (this.workingRequestEditCondition.requestRemarks) {
			this.shiftReason = true
		}
		if (this.editCondition.workingKbn == Const.WorkingKbn.HOLIDAY_WORK || this.editCondition.workingKbn == Const.WorkingKbn.INDIVIDUAL_SHIFT) {
			this.shiftReason = true
		}
		//休暇申請
		if (this.vacationRequestEditCondition.requestRemarks) {
			this.vacationReason = true
		}
		if (
			this.editCondition.vacationKbn != Const.VacationKbn.DEFAULT &&
			this.editCondition.vacationKbn != Const.VacationKbn.MIDNIGHT_VACATION &&
			this.editCondition.vacationKbn != Const.VacationKbn.TRANSFER_HOLIDAY
		) {
			this.vacationReason = true
		}
		//遅刻申請
		if (this.lateEarlyRequest1EditCondition.requestRemarks || this.selectLate != '') {
			this.lateReason = true
		}
		if (this.lateEarlyRequest2EditCondition.requestRemarks || this.selectLate2 != '') {
			this.late2 = true
			this.lateReason2 = true
		}

		//振替日
		this.showExchangeFrom = false
		this.showExchangeTo = false
		if (this.editCondition.vacationKbn == Const.VacationKbn.TRANSFER_HOLIDAY) {
			this.showExchangeFrom = true
		}
		if (this.editCondition.workingKbn == Const.WorkingKbn.HOLIDAY_WORK) {
			this.showExchangeTo = true
		}
		//在宅勤務
		if (this.editCondition.teleworkStart1 && this.editCondition.teleworkStart2) {
			this.teleWork = true
			this.teleWork2 = true
		} else if (this.editCondition.teleworkStart1 || this.editCondition.teleworkKbn == Const.TeleWork.TELEWORK_SCHEDULE) {
			this.teleWork = true
			this.teleWork2 = false
		} else {
			this.teleWork = false
			this.teleWork2 = false
		}
		//翌営業日明休日
		if (this.editCondition.workingKbn != Const.WorkingKbn.NON_WORKINGDAY && this.editCondition.offDutyDate != null)
		{
            this.isNextDayOffDuty = true
		}
		//休憩
		if (this.editCondition.workingKbn == Const.WorkingKbn.HOLIDAY_WORK || this.editCondition.workingKbn == Const.WorkingKbn.INDIVIDUAL_SHIFT) {
			this.breakdown = true
			this.shiftColor = 'yellow lighten-2'
		} else if (this.editCondition.restTimeChangeFlg) {
			this.breakdown = true
			this.shiftColor = 'white'
		} else {
			this.breakdown = false
			this.shiftColor = 'white'
		}
		//休日の場合 遅早退は選択不可
		if (this.editCondition.holidayKbn != Const.HolidayKbn.WEEKDAY) {
			this.disableRequest2 = true
		}

		//月次ステータスが申請中は登録・申請取消は触れない
		if (this.editCondition.monthlyStatus == Const.MonthlyStatus.AWAITING_APPROVAL) {
            //申請
            this.disableWorking = true
            this.disableVacation = true
            this.disableRequest2 = true
            this.disableVacationReason = true
            this.disableExchangeDateFrom = true
            this.disabledecision = true
            this.disableHoliday = true
            //ボタン
            this.disableSavebtn = true
            this.disableCancelbtn = true
            this.disableHolidayWorkbtn = true
        }

		//日次ステータスが締めたら何も触れない
		if (this.editCondition.dailyStatus == Const.DailyStatus.CLOSING) {
			//申請
			this.disableWorking = true
			this.disableVacation = true
			this.disableRequest2 = true
			this.disableVacationReason = true
            this.disableExchangeDateFrom = true
			this.disabledecision = true
			this.disableHoliday = true
			//ボタン
			this.disableSavebtn = true
			this.disableCancelbtn = true
			this.disableConfirmbtn = true
			this.disableApprovalbtn = true
			this.disableRejectbtn = true
			this.disableHolidayWorkbtn = true
			this.disableRemarks = true
		}
		//#endregion
	}
	//#endregion

	//#region 申請情報背景色
	private requestBackColor() {
		//申請（勤務）
		if (this.workingRequestEditCondition.requestStatus == Const.RequestStatus.AWAITING_APPROVAL) {
			this.workingRequestColor = 'orange lighten-3'
		} else if (
			this.workingRequestEditCondition.requestStatus == Const.RequestStatus.MAKING ||
			this.workingRequestEditCondition.requestStatus == Const.RequestStatus.REMAND
		) {
			this.workingRequestColor = 'red lighten-4'
		} else {
			this.workingRequestColor = 'white'
		}

		//申請（休暇）
		if (this.vacationRequestEditCondition.requestStatus == Const.RequestStatus.AWAITING_APPROVAL) {
			this.vacationRequestColor = 'orange lighten-3'
		} else if (
			this.vacationRequestEditCondition.requestStatus == Const.RequestStatus.MAKING ||
			this.vacationRequestEditCondition.requestStatus == Const.RequestStatus.REMAND
		) {
			this.vacationRequestColor = 'red lighten-4'
		} else {
			this.vacationRequestColor = 'white'
		}

		//申請（遅早退1）
		if (this.lateEarlyRequest1EditCondition.requestStatus == Const.RequestStatus.AWAITING_APPROVAL) {
			this.lateEarlyRequest1Color = 'orange lighten-3'
		} else if (
			this.lateEarlyRequest1EditCondition.requestStatus == Const.RequestStatus.MAKING ||
			this.lateEarlyRequest1EditCondition.requestStatus == Const.RequestStatus.REMAND ||
			(this.lateEarlyRequest1EditCondition.requestStatus == null && this.selectLate >= Const.LateEarlyKbn.LATE)
		) {
			this.lateEarlyRequest1Color = 'red lighten-4'
		} else {
			this.lateEarlyRequest1Color = 'white'
		}

		//申請（遅早退2）
		if (this.lateEarlyRequest2EditCondition.requestStatus == Const.RequestStatus.AWAITING_APPROVAL) {
			this.lateEarlyRequest2Color = 'orange lighten-3'
		} else if (
			this.lateEarlyRequest2EditCondition.requestStatus == Const.RequestStatus.MAKING ||
			this.lateEarlyRequest2EditCondition.requestStatus == Const.RequestStatus.REMAND ||
			(this.lateEarlyRequest2EditCondition.requestStatus == null && this.selectLate2 >= Const.LateEarlyKbn.LATE)
		) {
			this.lateEarlyRequest2Color = 'red lighten-4'
		} else {
			this.lateEarlyRequest2Color = 'white'
		}
	}
	//#endregion

	//#region 半休の時間設定
	private setOffTime() {
		//個別・休出でない場合上書き
		if (!this.freeShift) {
			if (
				this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_AM_BEFORE ||
				this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_AM_THEDAY ||
				this.editCondition.vacationKbn == Const.VacationKbn.SPECIAL_HOLIDAY_AM ||
				this.editCondition.vacationKbn == Const.VacationKbn.ABSENCE_AM
			) {
				//午前半休系
				this.editCondition.shiftTimeStart = this.baseTime.afternoonOffTimeStart
				this.editCondition.shiftTimeEnd = this.baseTime.afternoonOffTimeEnd
			} else if (
				this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_PM_BEFORE ||
				this.editCondition.vacationKbn == Const.VacationKbn.PAID_HOLIDAY_PM_THEDAY ||
				this.editCondition.vacationKbn == Const.VacationKbn.SPECIAL_HOLIDAY_PM ||
				this.editCondition.vacationKbn == Const.VacationKbn.ABSENCE_PM
			) {
				//午後半休系
				this.editCondition.shiftTimeStart = this.baseTime.morningOffTimeStart
				this.editCondition.shiftTimeEnd = this.baseTime.morningOffTimeEnd
			}
		}
	}
	//#endregion

	//#region 全日休暇の設定
	private setAlldayOff() {
		this.editCondition.wkTimeStart = ''
		this.editCondition.wkTimeEnd = ''
		this.editCondition.teleworkStart1 = ''
		this.editCondition.teleworkEnd1 = ''
		this.editCondition.teleworkStart2 = ''
		this.editCondition.teleworkEnd2 = ''
		this.teleWork = false
	}
	//#endregion

	//#region 非勤務日の設定
	private nonWorkingDay() {
		//時間項目初期化
		this.editCondition.shiftTimeStart = ''
		this.editCondition.shiftTimeEnd = ''
		this.editCondition.wkTimeStart = ''
		this.editCondition.wkTimeEnd = ''
		this.editCondition.teleworkStart1 = ''
		this.editCondition.teleworkEnd1 = ''
		this.editCondition.teleworkStart2 = ''
		this.editCondition.teleworkEnd2 = ''
		this.editCondition.restTimeStart1 = ''
		this.editCondition.restTimeEnd1 = ''
		this.editCondition.restTimeStart2 = ''
		this.editCondition.restTimeEnd2 = ''
		this.editCondition.restTimeStart3 = ''
		this.editCondition.restTimeEnd3 = ''
		this.editCondition.restTimeStart4 = ''
		this.editCondition.restTimeEnd4 = ''
		this.editCondition.restTimeStart5 = ''
		this.editCondition.restTimeEnd5 = ''
		this.editCondition.restTimeStart6 = ''
		this.editCondition.restTimeEnd6 = ''
		this.editCondition.restTimeStart7 = ''
		this.editCondition.restTimeEnd7 = ''
		this.editCondition.restTimeStart8 = ''
		this.editCondition.restTimeEnd8 = ''
		this.editCondition.restTimeStart9 = ''
		this.editCondition.restTimeEnd9 = ''
		this.editCondition.restTimeStart10 = ''
		this.editCondition.restTimeEnd10 = ''
		if (this.baseTime) {
			this.baseTime.shiftTimeStart = ''
			this.baseTime.shiftTimeEnd = ''
			this.baseTime.restTimeStart1 = ''
			this.baseTime.restTimeEnd1 = ''
			this.baseTime.restTimeStart2 = ''
			this.baseTime.restTimeEnd2 = ''
			this.baseTime.restTimeStart3 = ''
			this.baseTime.restTimeEnd3 = ''
			this.baseTime.restTimeStart4 = ''
			this.baseTime.restTimeEnd4 = ''
			this.baseTime.restTimeStart5 = ''
			this.baseTime.restTimeEnd5 = ''
			this.baseTime.restTimeStart6 = ''
			this.baseTime.restTimeEnd6 = ''
			this.baseTime.restTimeStart7 = ''
			this.baseTime.restTimeEnd7 = ''
			this.baseTime.restTimeStart8 = ''
			this.baseTime.restTimeEnd8 = ''
			this.baseTime.restTimeStart9 = ''
			this.baseTime.restTimeEnd9 = ''
			this.baseTime.restTimeStart10 = ''
			this.baseTime.restTimeEnd10 = ''
		}
		//遅早退
		this.selectLate = ''
		this.selectLate2 = ''
		this.lateEarlyRequest1EditCondition.requestRemarks = ''
		this.lateEarlyRequest2EditCondition.requestRemarks = ''
		this.disableRequest2 = true
		this.late2 = false
		//勤務申請
		this.shiftReason = false
		this.workingRequestEditCondition.requestRemarks = ''
		this.editCondition.exchangeDateTo = ''
		//翌営業日明休日
        this.isNextDayOffDuty = false
		//休憩内訳
		this.breakdown = false
		//在宅勤務
		this.teleWork = false
		this.teleWork2 = false

		//時間非活性
		this.timeInput = false
		this.restTimeInput = false
	}
	//#endregion

	//#region 休憩時間の設定
	private setRestTime() {
		this.editCondition.restTimeStart1 = this.baseTime.restTimeStart1
		this.editCondition.restTimeEnd1 = this.baseTime.restTimeEnd1
		this.editCondition.restTimeStart2 = this.baseTime.restTimeStart2
		this.editCondition.restTimeEnd2 = this.baseTime.restTimeEnd2
		this.editCondition.restTimeStart3 = this.baseTime.restTimeStart3
		this.editCondition.restTimeEnd3 = this.baseTime.restTimeEnd3
		this.editCondition.restTimeStart4 = this.baseTime.restTimeStart4
		this.editCondition.restTimeEnd4 = this.baseTime.restTimeEnd4
		this.editCondition.restTimeStart5 = this.baseTime.restTimeStart5
		this.editCondition.restTimeEnd5 = this.baseTime.restTimeEnd5
		this.editCondition.restTimeStart6 = this.baseTime.restTimeStart6
		this.editCondition.restTimeEnd6 = this.baseTime.restTimeEnd6
		this.editCondition.restTimeStart7 = this.baseTime.restTimeStart7
		this.editCondition.restTimeEnd7 = this.baseTime.restTimeEnd7
		this.editCondition.restTimeStart8 = this.baseTime.restTimeStart8
		this.editCondition.restTimeEnd8 = this.baseTime.restTimeEnd8
		this.editCondition.restTimeStart9 = this.baseTime.restTimeStart9
		this.editCondition.restTimeEnd9 = this.baseTime.restTimeEnd9
		this.editCondition.restTimeStart10 = this.baseTime.restTimeStart10
		this.editCondition.restTimeEnd10 = this.baseTime.restTimeEnd10
	}
	//#endregion

	//#region 在宅勤務 登録時に非表示の場合登録しない
	private EditTele() {
		//在宅勤務2を非表示にしている場合
		if (!this.teleWork2) {
			this.editCondition.teleworkStart2 = ''
			this.editCondition.teleworkEnd2 = ''
		}

		//在宅勤務非表示にしている場合
		if (!this.teleWork) {
			this.editCondition.teleworkStart1 = ''
			this.editCondition.teleworkEnd1 = ''
			this.editCondition.teleworkStart2 = ''
			this.editCondition.teleworkEnd2 = ''
			this.editCondition.teleworkKbn = Const.TeleWork.DEFAULT
		}
		//在宅勤務ONで時間入力がない場合 在宅予定
		if (this.teleWork && !this.editCondition.teleworkStart1 && !this.editCondition.teleworkEnd1) {
			this.editCondition.teleworkKbn = Const.TeleWork.TELEWORK_SCHEDULE
		}
	}
	//#endregion

    //#region 明休日 登録時に非表示の場合登録しない
    private EditOffDutyDate() {
        //明休日チェックボックスをOFFにしている場合
        if (!this.isNextDayOffDuty) {
            this.editCondition.offDutyDate = ''
        }
    }
	//#endregion

	//#region 決裁理由を各申請にセットする
	private setDecisionRemarks() {
		if (this.editCondition.decisionRemarks && !this.disabledecision) {
			if (this.workingRequestEditCondition.detailNo) {
				this.workingRequestEditCondition.decisionRemarks = this.editCondition.decisionRemarks
			}
			//振替休日は否認不可
			if (this.vacationRequestEditCondition.detailNo && this.vacationRequestEditCondition.vacationKbn != Const.VacationKbn.TRANSFER_HOLIDAY) {
				this.vacationRequestEditCondition.decisionRemarks = this.editCondition.decisionRemarks
			}
			if (this.lateEarlyRequest1EditCondition.detailNo) {
				this.lateEarlyRequest1EditCondition.decisionRemarks = this.editCondition.decisionRemarks
			}
			if (this.lateEarlyRequest2EditCondition.detailNo) {
				this.lateEarlyRequest2EditCondition.decisionRemarks = this.editCondition.decisionRemarks
			}
		}
	}
	//#endregion

	//#region 遅早退表示用⇒フラグ 設定
	private setLateEarlyFlg() {
		if (this.selectLate == this.selectLate2 && this.selectLate && this.selectLate2) {
			this.errorMessage(MsgConst.ATTENDANCE_ENTRY.ERROR_002)
			return false
		}

		if ((this.selectLate == Const.LateEarlyKbn.LATE && this.selectLate2 == Const.LateEarlyKbn.TRAIN_DELAY) || (this.selectLate == Const.LateEarlyKbn.TRAIN_DELAY && this.selectLate2 == Const.LateEarlyKbn.LATE)) {
			this.errorMessage(MsgConst.ATTENDANCE_ENTRY.ERROR_003)
			return false
		}

		//フラグセット
        if (this.selectLate == Const.LateEarlyKbn.LATE || this.selectLate2 == Const.LateEarlyKbn.LATE) {
			this.editCondition.tardyFlg = true
		} else {
			this.editCondition.tardyFlg = false
		}

		if (this.selectLate == Const.LateEarlyKbn.LEAVE_EARLY || this.selectLate2 == Const.LateEarlyKbn.LEAVE_EARLY) {
			this.editCondition.leavingEarlyFlg = true
		} else {
			this.editCondition.leavingEarlyFlg = false
		}
		if (this.selectLate == Const.LateEarlyKbn.TRAIN_DELAY || this.selectLate2 == Const.LateEarlyKbn.TRAIN_DELAY) {
			this.editCondition.trainDelayFlg = true
		} else {
			this.editCondition.trainDelayFlg = false
		}

		//申請区分セット
		this.lateEarlyRequest1EditCondition.requestKbn =
			this.selectLate == Const.LateEarlyKbn.LATE ? Const.RequestKbn.LATE : this.selectLate == Const.LateEarlyKbn.LEAVE_EARLY ? Const.RequestKbn.LEAVE_EARLY : this.selectLate == Const.LateEarlyKbn.TRAIN_DELAY ? Const.RequestKbn.TRAIN_DELAY : ''
		this.lateEarlyRequest2EditCondition.requestKbn =
            this.selectLate2 == Const.LateEarlyKbn.LATE ? Const.RequestKbn.LATE : this.selectLate2 == Const.LateEarlyKbn.LEAVE_EARLY ? Const.RequestKbn.LEAVE_EARLY : this.selectLate2 == Const.LateEarlyKbn.TRAIN_DELAY ? Const.RequestKbn.TRAIN_DELAY  : ''

		return true
	}
	//#endregion

	//#region 遅刻早退表示用 設定
	private displayLateEarly() {
		//申請なしでフラグのみの場合
		if (this.editCondition.tardyFlg) {
			this.selectLate = Const.LateEarlyKbn.LATE
		} else if (this.editCondition.trainDelayFlg) {
			this.selectLate = Const.LateEarlyKbn.TRAIN_DELAY
		} else if (this.editCondition.leavingEarlyFlg) {
			this.selectLate = Const.LateEarlyKbn.LEAVE_EARLY
		} else {
			this.selectLate = ''
			this.selectLate2 = ''
		}
		if (this.editCondition.tardyFlg && this.editCondition.leavingEarlyFlg) {
			this.selectLate = Const.LateEarlyKbn.LATE
            this.selectLate2 = Const.LateEarlyKbn.LEAVE_EARLY
		} else if (this.editCondition.trainDelayFlg && this.editCondition.leavingEarlyFlg) {
			this.selectLate = Const.LateEarlyKbn.TRAIN_DELAY
			this.selectLate2 = Const.LateEarlyKbn.LEAVE_EARLY
		}

		//申請がある場合（連動させる）
		if (this.lateEarlyRequest1EditCondition.requestKbn == Const.RequestKbn.LATE) {
            this.selectLate = Const.LateEarlyKbn.LATE
		} else if (this.lateEarlyRequest1EditCondition.requestKbn == Const.RequestKbn.TRAIN_DELAY) {
            this.selectLate = Const.LateEarlyKbn.TRAIN_DELAY
		} else if (this.lateEarlyRequest1EditCondition.requestKbn == Const.RequestKbn.LEAVE_EARLY) {
            this.selectLate = Const.LateEarlyKbn.LEAVE_EARLY
		}

        if (this.lateEarlyRequest2EditCondition.requestKbn == Const.RequestKbn.LATE) {
            this.selectLate2 = Const.LateEarlyKbn.LATE
        } else if (this.lateEarlyRequest2EditCondition.requestKbn == Const.RequestKbn.TRAIN_DELAY) {
            this.selectLate2 = Const.LateEarlyKbn.TRAIN_DELAY
        } else if (this.lateEarlyRequest2EditCondition.requestKbn == Const.RequestKbn.LEAVE_EARLY) {
            this.selectLate2 = Const.LateEarlyKbn.LEAVE_EARLY
		}
	}

	//#endregion

	//#region ダイアログイベント
	private dialogEvent(reply: string) {
		this.avoidMultipost(async () => {
			if (reply == 'yes') {
				//はいが押された場合
				switch (this.eventNm) {
				case 'edit':
					this.edit()
					break
				case 'cancel':
					this.cancel()
					break
				case 'confirm':
					this.confirm()
					break
				case 'approval':
					this.approval()
					break
				case 'reject':
					this.reject()
					break
				case 'overwriteTime':
					this.overwriteTime()
					break
				case 'setAlldayOff':
					this.setAlldayOff()
					break
				case 'cancelHolidayWork':
					this.cancelHolidayWork()
					break
				default:
					break
				}
			} else {
				//いいえが押された場合
				switch (this.eventNm) {
				case 'overwriteTime':
					this.changeBaseTime()
					break
				default:
					break
				}
			}
			//ダイアログを閉じる
			this.dialog = false
			this.eventNm = ''
		})
	}
	//#endregion

	//#region dialog
	private openDialog(title: string, msg: string) {
		this.title = title
		this.dialogMsg = msg
		this.dialog = true
	}
	//#endregion

	//#region エラーメッセージ
	private errorMessage(message: string) {
		this.showMessage = true
		this.messageType = 'error'
		this.message = message
	}
	//#endregion

	//#region メッセージクリア
	private clearMessage() {
		this.message = ''
		this.showMessage = false
        this.guidance = ''
        this.showGuidance = false
	}
	//#endregion

	//#region 初期化
	private init() {
		this.timeChangeFlg = false
		this.eventNm = ''

		//差戻状態
		this.disabledecision = false
		//カレンダー
		this.menu = false
		this.menu2 = false

		//申請理由
		this.shiftReason = false
		this.vacationReason = false
		this.lateReason = false
		this.lateReason2 = false
		this.workingRequestEditCondition.requestRemarks = ''
		this.vacationRequestEditCondition.requestRemarks = ''
		this.lateEarlyRequest1EditCondition.requestRemarks = ''
		this.lateEarlyRequest2EditCondition.requestRemarks = ''
		//特記事項
        this.editCondition.workingRemarks = ''
		//否認理由
		this.editCondition.decisionRemarks = ''
		//申請活性
		this.disableWorking = false
		this.disableVacation = false
		this.disableRequest2 = false
		this.disableVacationReason = false
        this.disableExchangeDateFrom = true		//システム化前の振替日発生日がある移行期間中のみ触れる。既定値は禁止しておく。
		//ボタン
		this.showSavebtn = false
		this.showCancelbtn = false
		this.showConfirmbtn = false
		this.showApprovalbtn = false
		this.showRejectbtn = false
		this.showHolidayWorkbtn = false
		this.disableSavebtn = true
		this.disableCancelbtn = true
		this.disableConfirmbtn = true
		this.disableApprovalbtn = true
		this.disableRejectbtn = true
        this.disableHolidayWorkbtn = true
		//遅早退
		this.selectLate = ''
		this.selectLate2 = ''
		this.late2 = false
        //翌営業日明休日
        this.isNextDayOffDuty = false
		//休憩内訳
		this.breakdown = false
		//在宅勤務
		this.teleWork = false
		this.teleWork2 = false
		//ログ
		this.showLog = false
		//振替日
		this.showExchangeFrom = false
		this.showExchangeTo = false
		this.editCondition.exchangeDateTo = ''
		this.editCondition.exchangeDateFrom = ''
		//時間項目
		if (this.editCondition.workingKbn == Const.WorkingKbn.NON_WORKINGDAY) {
			this.timeInput = false
			this.restTimeInput = false
		} else {
			this.timeInput = true
			this.restTimeInput = true
		}

		//個別シフト・休日出勤
		this.freeShift = false

		//時間項目初期化
		this.editCondition.shiftTimeStart = ''
		this.editCondition.shiftTimeEnd = ''
		this.editCondition.wkTimeStart = ''
		this.editCondition.wkTimeEnd = ''
		this.editCondition.teleworkStart1 = ''
		this.editCondition.teleworkEnd1 = ''
		this.editCondition.teleworkStart2 = ''
		this.editCondition.teleworkEnd2 = ''
		this.editCondition.restTimeStart1 = ''
		this.editCondition.restTimeEnd1 = ''
		this.editCondition.restTimeStart2 = ''
		this.editCondition.restTimeEnd2 = ''
		this.editCondition.restTimeStart3 = ''
		this.editCondition.restTimeEnd3 = ''
		this.editCondition.restTimeStart4 = ''
		this.editCondition.restTimeEnd4 = ''
		this.editCondition.restTimeStart5 = ''
		this.editCondition.restTimeEnd5 = ''
		this.editCondition.restTimeStart6 = ''
		this.editCondition.restTimeEnd6 = ''
		this.editCondition.restTimeStart7 = ''
		this.editCondition.restTimeEnd7 = ''
		this.editCondition.restTimeStart8 = ''
		this.editCondition.restTimeEnd8 = ''
		this.editCondition.restTimeStart9 = ''
		this.editCondition.restTimeEnd9 = ''
		this.editCondition.restTimeStart10 = ''
		this.editCondition.restTimeEnd10 = ''

	}
	//#endregion

	//#region ＄アイコンクリック_経費一覧画面へ遷移する
	private openCostList() {
        var workingDate = ''
        var workingYm = ''
        //YYYYMMDD形式に変換
        workingYm = (this.editCondition.workingYm).replace('-', '')
        workingDate = this.editCondition.workingDate.replace('-', '').replace('-', '')

        this.$router.push({
            name: 'CostList',
            params: {
                monthlyKbn: '0',
                workingDate: workingDate,
                workingYm: workingYm,
                empCd: this.editCondition.empCd,
                beforeViewName: 'AttendanceEntry',
                beforeViewParam1: this.searchCondition.beforeViewParam1,
                beforeViewParam2: this.searchCondition.beforeViewParam2,
                beforeViewParam3: this.searchCondition.beforeViewParam3
            }
        })
    }
	//#endregion

	//#endregion
}
